const DEV_COMPANY_ID = 'dev-company-001';

const DEV_COMPANY_PROFILE = {
  company_name: 'Rely Dev LLC',
  legal_name: 'Rely Dev LLC',
  ein: '12-3456789',
  formation_state: 'Delaware',
  business_sector: 'Technology services',
  company_description: 'Founder operating company for global billing.',
  company_size: '1-10',
  main_email: 'e2e@rely.business',
  main_phone: '+13055550142',
  website_url: 'https://rely.business',
  linkedin_url: null,
  headquarters_address: {
    line1: '251 Little Falls Drive',
    city: 'Wilmington',
    state: 'DE',
    postal_code: '19808',
    country: 'US',
  },
  directors: [
    {
      id: 'dev-owner-001',
      first_name: 'Maya',
      last_name: 'Chen',
      ownership_percentage: 100,
      address_line1: '251 Little Falls Drive',
      address_city: 'Wilmington',
      country_of_tax_residence: 'US',
      passport: 'A1234567',
    },
  ],
  members: [],
  profile_completion_percentage: 100,
};

const DEV_FINANCIAL_PROVIDERS = {
  banks: [
    {
      id: 'lili',
      name: 'Lili',
      service_type: 'bank',
      application_mode: 'direct',
      cta_label: 'Apply',
      description: 'Business banking onboarding prefilled from Rely.',
      description_en: 'Business banking onboarding prefilled from Rely.',
      description_es: 'Alta bancaria prellenada desde Rely.',
      is_available: true,
      logo: null,
      processing_time: '5-10 minutes',
    },
    {
      id: 'relay',
      name: 'Relay',
      service_type: 'bank',
      application_mode: 'assisted',
      cta_label: 'Coordinate',
      description: 'Team banking for founders operating across entities.',
      description_en: 'Team banking for founders operating across entities.',
      description_es: 'Banca para equipos que operan varias entidades.',
      is_available: false,
      logo: null,
      processing_time: '2-4 business days',
    },
    {
      id: 'mercury',
      name: 'Mercury',
      service_type: 'bank',
      application_mode: 'assisted',
      cta_label: 'Coordinate',
      description: 'Startup banking reviewed through a Rely handoff.',
      description_en: 'Startup banking reviewed through a Rely handoff.',
      description_es: 'Banca para startups con revisión asistida por Rely.',
      is_available: false,
      logo: null,
      processing_time: '2-4 business days',
    },
    {
      id: 'payoneer',
      name: 'Payoneer',
      service_type: 'bank',
      application_mode: 'assisted',
      cta_label: 'Coordinate',
      description: 'Global receiving account for international payouts.',
      description_en: 'Global receiving account for international payouts.',
      description_es: 'Cuenta global para cobros internacionales.',
      is_available: false,
      logo: null,
      processing_time: '3-5 business days',
    },
    {
      id: 'wise',
      name: 'Wise',
      service_type: 'bank',
      application_mode: 'assisted',
      cta_label: 'Coordinate',
      description: 'Multi-currency account for global founder operations.',
      description_en: 'Multi-currency account for global founder operations.',
      description_es: 'Cuenta multimoneda para operaciones globales.',
      is_available: false,
      logo: null,
      processing_time: '3-5 business days',
    },
  ],
  payment_processors: [
    {
      id: 'stripe',
      name: 'Stripe',
      service_type: 'payment_processor',
      application_mode: 'assisted',
      cta_label: 'Coordinate',
      description: 'Payment acceptance setup coordinated from Rely.',
      description_en: 'Payment acceptance setup coordinated from Rely.',
      description_es: 'Activación de pagos coordinada desde Rely.',
      is_available: true,
      logo: null,
      processing_time: '1-3 business days',
    },
  ],
  crypto_exchanges: [
    {
      id: 'kraken',
      name: 'Kraken',
      service_type: 'crypto_exchange',
      application_mode: 'assisted',
      cta_label: 'Coordinate',
      description: 'Crypto exchange access for eligible companies.',
      description_en: 'Crypto exchange access for eligible companies.',
      description_es: 'Acceso a exchange cripto para empresas elegibles.',
      is_available: false,
      logo: null,
      processing_time: '3-7 business days',
    },
  ],
};

const DEV_LILI_READINESS = {
  success: true,
  provider_id: 'lili',
  ready: true,
  missing_requirements: [],
  completed_requirements: [
    { code: 'business_profile', label: 'Company profile', category: 'company' },
    { code: 'business_ein', label: 'EIN', category: 'ein' },
    { code: 'business_address', label: 'Address', category: 'address' },
    { code: 'owners_profile', label: 'Owners', category: 'owners' },
    { code: 'contact_profile', label: 'Contact', category: 'contact' },
  ],
  prefill_summary: {
    company: true,
    ein: true,
    address: true,
    owners: true,
    contact: true,
  },
};

export const isE2ECommandFixtureEnabled = () =>
  process.env.NODE_ENV === 'test' &&
  process.env.REACT_APP_E2E_RELY_COMMAND_FIXTURE === 'true';

export const isE2ECommandLockedFixtureEnabled = () =>
  isE2ECommandFixtureEnabled() &&
  process.env.REACT_APP_E2E_RELY_COMMAND_LOCKED === 'true';

export const getE2ECommandCompany = () => ({
  id: DEV_COMPANY_ID,
  companyId: DEV_COMPANY_ID,
  name: 'Rely Dev LLC',
  status: 'completed',
  ein: '12-3456789',
  state: 'Delaware',
  createdAt: '2026-01-15T14:30:00Z',
  formationDate: '2026-01-22',
  profile: DEV_COMPANY_PROFILE,
  _raw: {
    company_id: DEV_COMPANY_ID,
    companyId: DEV_COMPANY_ID,
    registration_id: DEV_COMPANY_ID,
    registrationId: DEV_COMPANY_ID,
    company_name: 'Rely Dev LLC',
    legal_name: 'Rely Dev LLC',
    profile: DEV_COMPANY_PROFILE,
  },
});

export const getE2EFinancialProvidersFixture = () =>
  Object.fromEntries(
    Object.entries(DEV_FINANCIAL_PROVIDERS).map(([category, providers]) => [
      category,
      providers.map((provider) => ({ ...provider })),
    ])
  );

export const getE2EFinancialApplicationsFixture = () => [];

export const getE2EProviderReadinessFixture = (providerId) => {
  if (providerId === 'lili') {
    return {
      ...DEV_LILI_READINESS,
      missing_requirements: [...DEV_LILI_READINESS.missing_requirements],
      completed_requirements: DEV_LILI_READINESS.completed_requirements.map(
        (requirement) => ({ ...requirement })
      ),
      prefill_summary: { ...DEV_LILI_READINESS.prefill_summary },
    };
  }

  return {
    success: true,
    provider_id: providerId,
    ready: true,
    missing_requirements: [],
    completed_requirements: [],
    prefill_summary: {},
  };
};

const getLockedBillingFixture = () => ({
  subscription: {
    planType: 'none',
    packageKey: 'none',
    status: 'inactive',
    currentPeriodEnd: null,
    canceledAt: null,
    stripeSubscriptionId: null,
    hasRecurringSubscription: false,
    entitlements: [],
  },
  paymentMethods: [],
  billingHistory: [],
});

const getActiveBillingFixture = () => ({
  subscription: {
    planType: 'rely_membership',
    packageKey: 'rely_membership',
    status: 'active',
    currentPeriodEnd: '2026-06-18T00:00:00Z',
    canceledAt: null,
    stripeSubscriptionId: 'sub_dev_rely_command',
    hasRecurringSubscription: true,
    entitlements: [
      'invoicing.read',
      'invoicing.write',
      'proposals.read',
      'proposals.write',
    ],
  },
  paymentMethods: [
    {
      id: 'pm-dev-visa',
      brand: 'visa',
      last4: '4242',
      exp_month: 12,
      exp_year: 2028,
      is_default: true,
    },
  ],
  billingHistory: [
    {
      id: 'txn-dev-rely-command-renewal',
      type: 'subscription',
      description: 'Rely Command renewal',
      amount: 99,
      status: 'paid',
      created_at: '2026-05-18T00:00:00Z',
      payment_method: {
        brand: 'visa',
        last4: '4242',
      },
      invoice_url: null,
    },
  ],
});

export const getE2EBillingFixture = () =>
  isE2ECommandLockedFixtureEnabled()
    ? getLockedBillingFixture()
    : getActiveBillingFixture();

export const getE2ETaxFilingsFixture = () => [
  {
    id: 'dev-tax-filing-2024',
    filingType: 'FORM_5472',
    taxYear: 2024,
    status: 'COMPLETED',
    completedAt: '2025-04-12T10:00:00Z',
    createdAt: '2025-03-28T10:00:00Z',
    documentUrl: null,
  },
  {
    id: 'dev-tax-filing-2023',
    filingType: 'FORM_5472',
    taxYear: 2023,
    status: 'COMPLETED',
    completedAt: '2024-04-09T10:00:00Z',
    createdAt: '2024-03-20T10:00:00Z',
    documentUrl: null,
  },
];

export const getE2EInvoicingFixture = () => ({
  customers: [
    {
      id: 'dev-customer-001',
      name: 'Northstar Robotics',
      email: 'finance@northstar.example',
      contact_name: 'Maya Chen',
    },
    {
      id: 'dev-customer-002',
      name: 'Atlas Foundry',
      email: 'ops@atlasfoundry.example',
      contact_name: 'Leo Martinez',
    },
  ],
  invoices: [
    {
      id: 'dev-invoice-001',
      invoice_number: 'INV-2026-001',
      customer_record_id: 'dev-customer-001',
      status: 'sent',
      due_date: '2026-05-30',
      total_amount_cents: 480000,
      notes: 'Monthly operating support and finance workflow setup.',
      line_items: [
        {
          description: 'Rely Command setup',
          quantity: 1,
          unit_amount_cents: 180000,
        },
        {
          description: 'Founder finance operating support',
          quantity: 2,
          unit_amount_cents: 150000,
        },
      ],
    },
    {
      id: 'dev-invoice-002',
      invoice_number: 'INV-2026-002',
      customer_record_id: 'dev-customer-002',
      status: 'paid',
      due_date: '2026-05-10',
      total_amount_cents: 320000,
      notes: 'Formation handoff and first month support.',
      line_items: [
        {
          description: 'Launch support package',
          quantity: 1,
          unit_amount_cents: 320000,
        },
      ],
    },
    {
      id: 'dev-invoice-003',
      invoice_number: 'INV-2026-003',
      customer_record_id: 'dev-customer-001',
      status: 'overdue',
      due_date: '2026-05-05',
      total_amount_cents: 125000,
      notes: 'Additional compliance review block.',
      line_items: [
        {
          description: 'Compliance review',
          quantity: 1,
          unit_amount_cents: 125000,
        },
      ],
    },
  ],
  proposals: [
    {
      id: 'dev-proposal-001',
      proposal_number: 'PRO-2026-001',
      customer_record_id: 'dev-customer-001',
      status: 'draft',
      valid_until: '2026-06-20',
      total_amount_cents: 760000,
      notes: 'Three-week finance operations buildout.',
      line_items: [
        {
          description: 'Finance operations buildout',
          quantity: 1,
          unit_amount_cents: 760000,
        },
      ],
    },
    {
      id: 'dev-proposal-002',
      proposal_number: 'PRO-2026-002',
      customer_record_id: 'dev-customer-002',
      status: 'sent',
      valid_until: '2026-06-05',
      total_amount_cents: 540000,
      notes: 'Post-formation billing system launch.',
      line_items: [
        {
          description: 'Billing system launch',
          quantity: 1,
          unit_amount_cents: 540000,
        },
      ],
    },
  ],
});

export const getE2ECommandApprovalsFixture = () => ({
  approvals: [
    {
      approvalRequestId: 'dev-approval-invoice-001',
      companyId: DEV_COMPANY_ID,
      runId: 'dev-run-invoice-001',
      actionName: 'rely.invoice.send',
      externalService: 'rely',
      riskLevel: 'medium',
      status: 'pending',
      proposedPayloadSummary:
        'Send invoice REL-0004 to finance@northstar.example for USD 4,800.00',
      proposedPayloadHash: 'sha256:dev-invoice-approval',
      moneyAmountCents: 480000,
      currency: 'USD',
      requiredScopes: ['invoicing.invoices.send'],
      metadata: {
        entityType: 'invoice',
        entityId: 'dev-invoice-001',
        entityNumber: 'REL-0004',
        customerName: 'Northstar Robotics',
        recipientEmail: 'finance@northstar.example',
        requestedByActorType: 'AGENT',
        requestedByActorId: 'rely-command',
      },
      expiresAt: '2026-05-25T18:00:00Z',
      createdAt: '2026-05-18T18:00:00Z',
      updatedAt: '2026-05-18T18:04:00Z',
    },
    {
      approvalRequestId: 'dev-approval-proposal-001',
      companyId: DEV_COMPANY_ID,
      runId: 'dev-run-proposal-001',
      actionName: 'rely.proposal.send',
      externalService: 'rely',
      riskLevel: 'medium',
      status: 'pending',
      proposedPayloadSummary:
        'Send proposal PRP-0007 to ops@atlasfoundry.example for USD 7,600.00',
      proposedPayloadHash: 'sha256:dev-proposal-approval',
      moneyAmountCents: 760000,
      currency: 'USD',
      requiredScopes: ['proposals.send'],
      metadata: {
        entityType: 'proposal',
        entityId: 'dev-proposal-001',
        entityNumber: 'PRP-0007',
        customerName: 'Atlas Foundry',
        recipientEmail: 'ops@atlasfoundry.example',
        requestedByActorType: 'AGENT',
        requestedByActorId: 'rely-command',
      },
      expiresAt: '2026-05-25T18:10:00Z',
      createdAt: '2026-05-18T18:10:00Z',
      updatedAt: '2026-05-18T18:10:00Z',
    },
  ],
});
